import { useCreateLoyaltyConfigMutation } from '@/services/innovorder/modules/modules.endpoints';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

const useCreateComoConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [createConfig, { isLoading: isCreating, error: createError }] = useCreateLoyaltyConfigMutation();
    const {
        control,
        handleSubmit,
        reset,
        formState: { isDirty },
    } = useForm<{ comoApiKey: string }>({
        mode: 'all',
    });

    const onSubmit = (data: { comoApiKey: string }) => {
        createConfig({
            restaurantId: Number(restaurantId),
            apiKey: data.comoApiKey,
            provider: 'como',
        });
        reset();
    };
    return { createConfig, isCreating, onSubmit, control, handleSubmit, isDirty, createError };
};

export default useCreateComoConfig;
